export const PRODUCTS_PER_ROW = 4;
export const RMN_POSITION_OFFSET = 2;
export const PRODUCTS_BETWEEN_ROWS = 8;
export const AD_POSITIONER_TAG = 'positioner';
export const AD_SPONSORED_TAG = 'sponsored';
